import { Card } from "react-bootstrap";
import { Line } from "react-chartjs-2";

const QRFunnelChart = ({ qrOverview }) => {
  const daily = qrOverview?.dailyFunnel || [];

  const qrFunnelData = {
    labels: daily.map((d) => d.date.slice(5)), // show MM-DD
    datasets: [
      {
        label: "Scans",
        data: daily.map((d) => d.scans),
        borderColor: "#6c757d",
        backgroundColor: "rgba(108,117,125,0.15)",
        tension: 0.3,
        fill: true,
      },
      {
        label: "Tips entered",
        data: daily.map((d) => d.tipIntents),
        borderColor: "#0d6efd",
        backgroundColor: "rgba(13,110,253,0.12)",
        tension: 0.3,
        fill: true,
      },
      {
        label: "Tips completed",
        data: daily.map((d) => d.successfulTips),
        borderColor: "#198754",
        backgroundColor: "rgba(25,135,84,0.12)",
        tension: 0.3,
        fill: true,
      },
    ],
  };

  const qrFunnelOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  };

  return (
    <Card className="h-100 shadow-sm" style={{ minHeight: 320 }}>
      <Card.Body>
        <Card.Title>QR Code Analytics</Card.Title>
        <div style={{ height: 260 }}>
          <Line data={qrFunnelData} options={qrFunnelOptions} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default QRFunnelChart;
